// extracted by mini-css-extract-plugin
export default {"count-badge":"CountBadge_count-badge__7bPQn"};